// extracted by mini-css-extract-plugin
module.exports = {"menuBlocksList":"MenuBlocksList_menuBlocksList__30bT2","menuListItemBlock":"MenuBlocksList_menuListItemBlock__3pFnv"};